import React from 'react'

function Footer() {
  return (
    <footer class="main-footer footer-style-one">
      <div class="bg bg-pattern-1 bounce-y"></div>

      <div class="widgets-section style-two">
        <div class="auto-container">
          <div class="row">
            
            <div class="footer-column col-lg-3 col-md-6 col-sm-12">
              <div class="footer-widget about-widget">
                <div class="widget-content">
                  <div class="logo">
                    <a href="#"> <img src="images/logo-2.png" alt="Image" title="Love Bite" /></a>
                  </div>
                  <div class="text">There are many variations of <br />passages of is but the majority have <br />suffered aut fugit, sed quia</div>
                  <ul class="social-icon-one">
                    <li><a href="#"><i class="fab fa-facebook-f"></i></a></li>
                    <li><a href="#"><i class="fab fa-twitter"></i></a></li>
                    <li><a href="#"><i class="fab fa-linkedin-in"></i></a></li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="footer-column col-lg-3 col-md-6 col-sm-12 mb-0">
              <div class="footer-widget links-widget">
                <h6 class="widget-title">Useful Links</h6>
                <div class="widget-content">
                  <ul class="user-links">
                    <li><a href="#">Wedding Planning</a></li>
                    <li><a href="#">Decoration</a></li>
                    <li><a href="#">Food & Feast</a></li>
                    <li><a href="#">Team Members</a></li>
                    <li><a href="page-contact.html">Contact</a></li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="footer-column col-lg-3 col-md-6 col-sm-12 mb-0">
              <div class="footer-widget links-widget">
                <h6 class="widget-title">About Us</h6>
                <div class="widget-content">
                  <ul class="user-links">
                    <li><a href="#">Career</a></li>
                    <li><a href="#">Our Community</a></li>
                    <li><a href="#">Weeding Package</a></li>
                    <li><a href="#">Team Members</a></li>
                    <li><a href="#">Policy</a></li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="footer-column col-lg-3 col-md-6 col-sm-12">
              <div class="footer-widget contact-widget">
                <h6 class="widget-title">Contact Us</h6>
                <div class="widget-content">
                  <ul class="contact-list style-two">
                    <li class="contact-info">
                      <i class="icon fal fa-phone"></i>
                      <a href="#" class="tel:+91-458-654-528">+91 458 654 528</a>
                    </li>
                    <li class="contact-info">
                      <i class="icon fal fa-envelope"></i>
                      <a href="#" class="mailto:info@example.com"><span class="__cf_email__" data-cfemail="157c7b737a55706d74786579703b767a78">[email&#160;protected]</span></a>
                    </li>
                    <li class="contact-info">
                      <i class="icon fal fa-map-marker-alt"></i>
                      30 Commercial Road <br />Fratton, Australia
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="footer-bottom">
        <div class="auto-container">
          <div class="inner-container">
            <div class="copyright-text">© Copyrights reserved by kodesolution.</div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer